import { render } from "./RegisterStep6.vue?vue&type=template&id=4fc409ee&scoped=true"
import script from "./RegisterStep6.vue?vue&type=script&lang=js"
export * from "./RegisterStep6.vue?vue&type=script&lang=js"

import "./RegisterStep6.vue?vue&type=style&index=0&id=4fc409ee&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4fc409ee"]])

export default __exports__